import React from "react";
import {
  Box,
  Container,
  Flex,
  Heading,
  Text,
  VStack,
} from "@chakra-ui/react";
import Customerservicebot from "./customerservicesbot";
import Footer from "../components/footer";

export default function RefundPolicy() {
  return (
    <>
      <Customerservicebot />
      <Box>
        <Container maxW="full" centerContent overflow="hidden">
          <Flex>
            <Box maxW="1500px" mx="auto" px={4} mt={10}>
              <Heading as="h3" style={{ margin: "30px", textAlign:"center", color: "#3A56D4" }}>
                Refund Policy
              </Heading>
              <VStack align="left" style={{marginLeft:"50px",marginRight:"50px",fontSize:"16px"}} spacing={4}>
                <Text>
                  REFUNDS - Unlimiteye Product & Services inclusive of Aptofy services All Sales Are Final And No Refund Will Be Issued.
                </Text>
                <Text>
                  If you need to request a refund or cancel a project with Unlimiteye Solutions Pvt. Ltd., contact us at contactus@unlimiteye.com
                </Text>
                <Text fontWeight="bold">1. Eligible Situations for Refunds</Text>
                <Text style={{marginLeft:"10px"}}>a. Refund requests must be accompanied by a valid reason for dissatisfaction with our services. </Text>
                <Text style={{marginLeft:"10px"}}>b. Refunds will only be considered for projects that have been paid in full and have not commenced.</Text>
                <Text fontWeight="bold">2. Non-eligible Situations for Refunds:</Text>
                <Text style={{marginLeft:"10px"}}>a. If the project has been completed and delivered successfully within the agreed-upon specifications.</Text>
                <Text style={{marginLeft:"10px"}}>b. If the client changes their mind or decides not to proceed with the project after it has commenced</Text>
                <Text fontWeight="bold">Refund Process:</Text>
                <Text style={{marginLeft:"10px"}}>a. To request a refund, the client must contact our customer support team via email or phone, providing all relevant details. </Text>
                <Text style={{marginLeft:"10px"}}>b. Our team will review the refund request and assess its eligibility based on the provided information.</Text>
                <Text style={{marginLeft:"10px"}}>c. If the refund request is approved, the client will receive a refund within 30 days via the original payment method used.</Text>
                <Text fontWeight="bold">Cancellations Policy:</Text>
                <Text style={{marginLeft:"10px"}}>a. Clients may request project cancellation before the commencement of Resource Allocation or Design work.</Text>
                <Text style={{marginLeft:"10px"}}>b. Project cancellations requested after Design work has begun may be subject to cancellation fees.</Text>
                <Text fontWeight="bold">Cancellation Fees:</Text>
                <Text style={{marginLeft:"10px"}}>a. If the cancellation occurs within 24 hours of project initiation, no cancellation fees will be charged.</Text>
                <Text style={{marginLeft:"10px"}}>b. If the cancellation occurs after 24 hours of project initiation, a cancellation fee will be applicable based on the work completed and resources utilized up to that point.</Text>
                <Text fontWeight="bold">Communication of Cancellation:</Text>
                <Text style={{marginLeft:"10px"}}>a. To cancel a project, the client must notify our customer support team in writing, clearly stating the reasons for cancellation.</Text>
                <Text style={{marginLeft:"10px"}}>b. Our team will acknowledge the cancellation request and provide further instructions regarding any applicable cancellation fees.</Text>
                <Text><b>Note:</b> The refunds and cancellations policy mentioned above applies to standard projects and does not cover any customized or specialized services. For such cases, we will communicate specific refund and cancellation terms based on the nature of the project and the agreements made between Unlimiteye Solutions Pvt. Ltd. and the client.</Text>
                <Text>We value our clients and aim to maintain strong relationships by providing top-notch services. If you have any questions or concerns regarding our refunds and cancellations policy, please feel free to reach out to our customer support team, who will be happy to assist you.</Text>
                <Text fontWeight="bold">Disclaimer: This refunds and cancellations policy is subject to change at the discretion of Unlimiteye Solutions Pvt. Ltd. It is advisable to refer to the most recent version available on our official website or contact our customer support team for the most up-to-date information.</Text>
                <Text fontWeight="bold">QUESTIONS</Text>
                <Text>If You Have Any Questions Concerning Our Return/Cancellation Policy, Please Contact Us At:</Text>
                <Text><a href="https://www.aptofy.com/contactPage" style={{textDecoration:"underline",color:"#3A56D4;"}}>contactus@unlimiteye.com</a></Text>
                <Text><a href="https://www.aptofy.com" style={{textDecoration:"underline",color:"#3A56D4;"}}>aptofycare@unlimiteye.com</a></Text>
              </VStack>
              <br/>
            </Box>
          </Flex>
        </Container>
        <Footer />
      </Box>
    </>
  );
}
